import { useParams } from "react-router-dom";
import { useCollection } from "react-firebase-hooks/firestore";
import { collection } from "firebase/firestore";
import { useFirestore } from "../../contexts/FirestoreProvider";
import { useGame } from "../../contexts/GameProvider";

import RedFlag from "../Icon/RedFlag/RedFlag";

import "./Results.css";

export default function Results() {
    /**
     * Get our database
     */
    const { db } = useFirestore();

    const { gameState, clearResults } = useGame();

    const { id } = useParams();

    /**
     * Use Firestore collection data to get Results
     */
    const [results, loading] = useCollection(
        id !== false && id !== undefined
            ? collection(db, "rooms", id, "results")
            : "",
        {
            idField: "id",
            snapshotListenOptions: { includeMetadataChanges: true },
        }
    );

    if (loading) {
        return <div>Loading…</div>;
    }

    return (
        <div className="results">
            {!results.empty ? (
                <>
                    <table className="results-table">
                        <thead>
                            <tr>
                                <th></th>
                                {results.docs
                                    .sort(
                                        (a, b) =>
                                            a.data().timestamp -
                                            b.data().timestamp
                                    )
                                    .map((row, index) => (
                                        <th key={index}>{row.data().name}</th>
                                    ))}
                                <th>% Correct</th>
                            </tr>
                        </thead>
                        <tbody>
                            {gameState.subtitles.map((el, index) => (
                                <tr key={index}>
                                    <td>
                                        <span className="timestamp">
                                            {new Date(el.startTime * 1000)
                                                .toISOString()
                                                .substring(14, 19)}{" "}
                                            {el.redFlag && (
                                                <RedFlag size="0.75em" />
                                            )}
                                        </span>
                                        <br />
                                        {el.text}
                                    </td>
                                    {results.docs
                                        .sort(
                                            (a, b) =>
                                                a.data().timestamp -
                                                b.data().timestamp
                                        )
                                        .map((row, userIndex) => (
                                            <td
                                                key={userIndex}
                                                className={
                                                    row.data().answers[index]
                                                        ? gameState.subtitles[
                                                              index
                                                          ].redFlag !==
                                                          row.data().answers[
                                                              index
                                                          ]
                                                            ? "incorrect"
                                                            : "correct"
                                                        : "default"
                                                }
                                            >
                                                {row.data().answers[index] && (
                                                    <RedFlag size="0.75em" />
                                                )}
                                            </td>
                                        ))}
                                    <td>
                                        {gameState.subtitles[index].redFlag &&
                                            `${(
                                                (results.docs
                                                    .map(
                                                        (row) =>
                                                            row.data().answers[
                                                                index
                                                            ]
                                                    )
                                                    .filter((row) => row)
                                                    .length /
                                                    results.docs.length) *
                                                100
                                            ).toFixed(1)}%`}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                        <tfoot>
                            <td></td>
                            {results.docs
                                .sort(
                                    (a, b) =>
                                        a.data().timestamp - b.data().timestamp
                                )
                                .map((row, index) => (
                                    <td key={index}>
                                        {
                                            gameState.subtitles.filter(
                                                (el, index) =>
                                                    el.redFlag ===
                                                        row.data().answers[
                                                            index
                                                        ] &&
                                                    row.data().answers[index]
                                            ).length
                                        }
                                    </td>
                                ))}
                            <td></td>
                        </tfoot>
                    </table>
                    <button
                        onMouseUp={() => {
                            // Confirm deletion
                            const confirmDelete = window.confirm(
                                "Are you sure you want to clear all results for this room? This action cannot be undone."
                            );

                            if (!confirmDelete) return;

                            if (!id) return;

                            clearResults(id);
                        }}
                        style={{ margin: "1em auto" }}
                        className="btn"
                    >
                        Clear Results
                    </button>
                </>
            ) : (
                <p>No results to display</p>
            )}
        </div>
        // return (
        //   <div className="results">
        //     {!results.empty ? (
        //       <table className="results-table">
        //         <thead>
        //           <tr>
        //             <th>Name</th>
        //             {gameState.subtitles.map((question, index) => (
        //               <th key={index}>
        //                 {index + 1}
        //                 {gameState.subtitles[index].redFlag && " (🚩)"}
        //               </th>
        //             ))}
        //             <th>Total</th>
        //           </tr>
        //         </thead>
        //         <tbody>
        //           {results.docs
        //             .sort((a, b) => a.data().timestamp - b.data().timestamp)
        //             .map((row, index) => (
        //               <tr key={index}>
        //                 <td>{row.data().name}</td>
        //                 {row.data().answers.map((question, index) => (
        //                   <td
        //                     key={index}
        //                     className={
        //                       question
        //                         ? gameState.subtitles[index].redFlag !== question
        //                           ? "incorrect"
        //                           : "correct"
        //                         : "default"
        //                     }
        //                   >
        //                     {question && "🚩"}
        //                   </td>
        //                 ))}
        //                 <td>
        //                   {
        //                     gameState.subtitles.filter(
        //                       (el, index) =>
        //                         el.redFlag === row.data().answers[index] &&
        //                         row.data().answers[index]
        //                     ).length
        //                   }
        //                 </td>
        //               </tr>
        //             ))}
        //         </tbody>
        //         <tfoot>
        //           <tr>
        //             <th></th>
        //             {gameState.subtitles.map((question, index) => (
        //               <th key={index}>
        //                 {gameState.subtitles[index].redFlag &&
        //                   `${(
        //                     (results.docs
        //                       .map((row) => row.data().answers[index])
        //                       .filter((row) => row).length /
        //                       results.docs.length) *
        //                     100
        //                   ).toFixed(1)}%`}
        //               </th>
        //             ))}
        //             <th></th>
        //           </tr>
        //         </tfoot>
        //       </table>
        //     ) : (
        //       <p>No results to display</p>
        //     )}
        //   </div>
    );
}
